import {DEFAULT_CABIN_CLASS_INDEX} from '../flights-routes';

export default function FlightsMultitripController(
    $scope,
    $state,
    $window,
    flightsFactory,
    flightsService,
    userService,
    l10nService
) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        $onInit,
    });

    Object.assign($scope, {
        getPreviousSegment,
    });

    const emailSubject = l10nService.localize('Multiple-Stop Travel Request Assistance');
    $scope.userData = userService.getUser();
    $scope.multiStopMoreOptionsTemplate = 'app/modules/flights/templates/multi-stop-more-options.html';
    $scope.mailTo = 'mailto:' + $scope.userData.TeamColourEmail + '?subject=' + emailSubject;
    $scope.openMailTo = function() {
        $window.location = $scope.mailTo;
    };

    $scope.isCurrentDay = flightsService.isCurrentDay;

    function $onInit() {
        flightsFactory.params.SegmentFilterData = flightsFactory.segmentFilterData = [];
        initMultiTripCabinClasses();
    }

    function getPreviousSegment(index) {
        return index === 0 ? null : $scope.params.TicketSearchSegments[index - 1];
    }

    function initMultiTripCabinClasses() {
        const {TicketSearchSegments} = $scope.params;
        TicketSearchSegments.forEach((segment) => {
            if (!segment.cabinClass) {
                segment.cabinClass = angular.copy($scope.options.cabinClasses[DEFAULT_CABIN_CLASS_INDEX]);
            }
        });
    }

    $scope.showOptions = flightsFactory.showOptions;

    $scope.findFlights = function() {
        $scope.params.flightType = 'multitrip';
        flightsFactory.fetchFlights(angular.copy($scope.params))
            .then(
            function() {
                $state.go('main.flights.results.multi');
            }
        );

    };
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsMultitripCtrl.js